import { render } from "./DropboxDashboard.vue?vue&type=template&id=60922868&scoped=true"
import script from "./DropboxDashboard.vue?vue&type=script&lang=js"
export * from "./DropboxDashboard.vue?vue&type=script&lang=js"

import "./DropboxDashboard.vue?vue&type=style&index=0&id=60922868&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60922868"]])

export default __exports__